// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from 'he';
import { faClock, faStar } from "@fortawesome/free-regular-svg-icons";
import { faCoins, faHouseUser, faShoePrints, faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";

interface ServicesProps {
    agencyId: number;
}

const Services: React.FC<ServicesProps> = ({agencyId}) => {

    const { t } = useTranslation();

    const { agency } = useGetAgencyDetails(agencyId);

    const services = [
        {
            title: t('servicesPage.service1.title'),
            description: t('servicesPage.service1.description'),
            icon: <FontAwesomeIcon icon={faClock} />
        },
        {
            title: t('servicesPage.service2.title'),
            description: t('servicesPage.service2.description'),
            icon: <FontAwesomeIcon icon={faStar} />
        },
        {
            title: t('servicesPage.service3.title'),
            description: t('servicesPage.service3.description'),
            icon: <FontAwesomeIcon icon={faWandMagicSparkles} />
        },
        {
            title: t('servicesPage.service4.title'),
            description: t('servicesPage.service4.description'),
            icon: <FontAwesomeIcon icon={faHouseUser} />
        },
        {
            title: t('servicesPage.service5.title'),
            description: t('servicesPage.service5.description'),
            icon: <FontAwesomeIcon icon={faShoePrints} />
        },
        {
            title: t('servicesPage.service6.title'),
            description: t('servicesPage.service6.description'),
            icon: <FontAwesomeIcon icon={faCoins} />
        }
    ]

    return (
        <>
            <Helmet>
                <title>{t('servicesPage.pageTitle')} | {he.decode(`${agency?.agencyName}`) || 'Agenzia Immobiliare'}</title>
            </Helmet>

            <SubHeaderDefault title={t('servicesPage.subHeaderTitle')} isSeo={true} />

            <main id="services-page" className="space-ptb">
                <div className="container-fluid w-special">
                    <p className="sub-title">{t('servicesPage.subTitle')}</p>
                    <h2 className="mb-5" dangerouslySetInnerHTML={{ __html: t('servicesPage.title') as string }} />
                    <div className="row justify-content-between">
                        {services.map((service, index) => (
                            <div className="col-12 col-sm-11 col-lg-6 col-xl-5" key={index}>
                                <div className="service-card">
                                    <i className="service-icon">{service.icon}</i>
                                    <div>
                                        <h3>{service.title}</h3>
                                        <p>{service.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </>
    );
};

export default Services;